// extracted by mini-css-extract-plugin
export default {"productName":"productName___waNMp","truncated":"truncated___LgdiO"};